import { render, staticRenderFns } from "./NotificationDelete.vue?vue&type=template&id=3609e160&"
import script from "./NotificationDelete.vue?vue&type=script&lang=js&"
export * from "./NotificationDelete.vue?vue&type=script&lang=js&"
import style0 from "./NotificationDelete.vue?vue&type=style&index=0&id=3609e160&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports